
import { SiteCatchment } from "@/types";

export const filterCatchmentByCategory = (catchment: SiteCatchment[], categories: string[]) => {
  return catchment.filter(c => categories.includes(c.category));
}

export const filterCatchmentByDayType = (catchment: SiteCatchment[], dayType: string) => {
  return catchment.filter(x => x.day_type === dayType);
}

export const filterCatchment = (catchment: SiteCatchment[], categories: string[], dayType: string) => {
  return filterCatchmentByCategory(filterCatchmentByDayType(catchment, dayType), categories);
}
